/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AboutInputs */

const en_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const fr_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const de_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um`)
};

const it_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di`)
};

const ru_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О`)
};

const es_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const zh_cn2_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于`)
};

const ja_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`について`)
};

const hi_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के बारे में`)
};

const pt_pt2_about = /** @type {(inputs: AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {AboutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const about = /** @type {((inputs?: AboutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AboutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_about(inputs)
	if (locale === "de") return de_about(inputs)
	if (locale === "it") return it_about(inputs)
	if (locale === "ru") return ru_about(inputs)
	if (locale === "es") return es_about(inputs)
	if (locale === "zh-CN") return zh_cn2_about(inputs)
	if (locale === "ja") return ja_about(inputs)
	if (locale === "hi") return hi_about(inputs)
	if (locale === "pt-PT") return pt_pt2_about(inputs)
	return en_about(inputs)
});